import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-video.component.scss';
var BannerMidPageVideo = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageVideo, _super);
    function BannerMidPageVideo(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageVideo.prototype.init = function () {
    };
    BannerMidPageVideo.prototype.bindEvents = function () {
    };
    return BannerMidPageVideo;
}(Base));
export { BannerMidPageVideo };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-video/banner-mid-page-video.component.ts
// module id = 140
// module chunks = 0